import React from 'react';
import { Map, Grid, Clock, ShieldCheck, FileText, Calendar, AlertTriangle } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: <Map className="w-6 h-6" data-id="element-98" />,
    title: 'El mapa rápido de lesiones',
    desc: 'Diferencia nervio, músculo y tendón al instante.'
  }, {
    icon: <Grid className="w-6 h-6" data-id="element-99" />,
    title: 'La Matriz 4C completa',
    desc: 'Indicadores claros para saber tu fase exacta.'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-100" />,
    title: 'Micro-dosis de movimiento',
    desc: 'Rutinas de 5–12 min para días difíciles.'
  }, {
    icon: <ShieldCheck className="w-6 h-6" data-id="element-101" />,
    title: 'Cómo cargar sin romper',
    desc: 'Progresiones simples y el error #1 de las recaídas.'
  }, {
    icon: <FileText className="w-6 h-6" data-id="element-102" />,
    title: 'Plantillas por caso',
    desc: 'Guías específicas para lumbar, tendón y más.'
  }, {
    icon: <Calendar className="w-6 h-6" data-id="element-103" />,
    title: 'Plan de 21 días',
    desc: 'Tu ruta para salir del estancamiento.'
  }, {
    icon: <AlertTriangle className="w-6 h-6" data-id="element-104" />,
    title: '"Semáforo de evidencia"',
    desc: 'Qué sirve de verdad y qué es puro marketing.'
  }];
  return <section className="w-full bg-[#F5F0E6] py-12 px-4 sm:py-16 sm:px-6 md:py-28" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <div className="text-center mb-10" data-id="element-107">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4C1D95] mb-4" data-id="element-108">
            Qué incluye
          </h2>
          <p className="text-lg text-[#555555]" data-id="element-109">
            Sin relleno. Solo herramientas usables.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-110">
          {items.map((item, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-sm border border-[#E8E3D9] flex items-start" data-id="element-111">
              <div className="p-2 bg-[#7C3AED]/10 rounded-lg text-[#7C3AED] mr-4 flex-shrink-0" data-id="element-112">
                {item.icon}
              </div>
              <div data-id="element-113">
                <h3 className="text-lg font-bold text-[#4C1D95] mb-1" data-id="element-114">
                  {item.title}
                </h3>
                <p className="text-sm text-[#555555]" data-id="element-115">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}